/*
 * This is a stripped-down version of the service present in md-date-range-picker.js,
 * so that we can:
 *  - handle translations without filling a translationMap
 *  - disable the OK button if only one date is selected 
 *    (and, in case of a mandatory range, if neither start and end date are selected)
 *  - style the cancel button properly (it is not 'raised' in the service provided by the md-date-range-picker lib)
 * 
 */
export class DateRangePickerDialogService {

  constructor($mdDialog) {
    this.$mdDialog = $mdDialog;
  }

  show(config) {

    return this.$mdDialog.show({
      locals: {
        serviceConfig: config
      },
      controller: ['$scope', '$mdDialog', 'serviceConfig', function ($scope, $mdDialog, serviceConfig) {
        $scope.config = serviceConfig || {};
        $scope.model = {
          fromDate: serviceConfig.fromDate,
          toDate: serviceConfig.toDate
        };
        $scope.ok = function () {
          $mdDialog.hide($scope.model);
        };
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
        $scope.clear = function clear() {
          $scope.model.selectedTemplateName = '';
          $scope.model.fromDate = null;
          $scope.model.toDate = null;
        };
        $scope.isValid = function () {
          const bothSet = $scope.model.fromDate && $scope.model.toDate;
          const eitherBothOrNoneSet = !$scope.model.fromDate == !$scope.model.toDate;
          return config.isMandatory ? bothSet : eitherBothOrNoneSet;
        };
        let now = new Date();
        $scope.isDisabledDate = serviceConfig.noMaxDate ?
          function () {
            return false;
          } :
          function (date) {
            return date > now || date < serviceConfig.minDate;
          };
      }],
      template: require('./date-range-picker.dialog.html'),
      targetEvent: config.targetEvent || document.body,
      clickOutsideToClose: true
    });
  }

  static DateRangePickerDialogFactory($mdDialog) {
    return new DateRangePickerDialogService($mdDialog);
  }
}

DateRangePickerDialogService.DateRangePickerDialogFactory.$inject = ['$mdDialog'];

